<input
  #textField
  type="text"
  #instance="ngbTypeahead"
  class="form-control mb-2"
  container="body"
  [resultTemplate]="itemTemplate"
  [inputFormatter]="inputFormatter"
  [placeholder]="placeholder"
  [ngbTypeahead]="search"
  [attr.data-cy]="dataCy"
  [disabled]="disabled"
  (focus)="focus$.next($event.target.value)"
  (click)="click$.next($event.target.value)"
  (selectItem)="selectItem($event)"
/>

<ng-template #itemTemplate let-r="result" let-t="term">
  <ngb-highlight [result]="r[displayPropertyName]" [term]="t"></ngb-highlight>
</ng-template>
